export const fundGuideNn = {
    fundGuide: {
        highlighted: {
            title: 'Framheva treff',
            selectionLabel: 'Framheva treff',
            remove: 'Fjern tilrådingane frå fondsguiden',
            loading: 'Hentar tilrådde fond',
            empty: 'Ingen tilrådde fond er tilgjengelege for vald betalingstype.',
            errorTitle: 'Vi kunne ikkje hente tilrådde fond',
            errorBody: 'Det oppstod ein feil då vi henta tilrådde fond. Prøv igjen.',
            retry: 'Prøv igjen',
        },
        title: 'Finn din fondstype',
        introDescription: 'Få forslag til fondstypar som passar til vald tidsperiode og kor mykje svingingar du er komfortabel med. Dette er generell rettleiing, ikkje rådgiving eller ei tilråding.',
        chooseOption: 'Vel',
        savingPeriod: {
            label: 'Spareperiode',
            choices: {
                underTwoYears: 'Under 2 år',
                twoToFiveYears: '2-5 år',
                fivePlusYears: '5+ år',
            },
            infoLabel: 'Om perioden',
            infoTitle: 'Om spareperiode',
        },
        riskTolerance: {
            label: 'Risikotoleranse',
            choices: {
                cautious: 'Forsiktig',
                someRisk: 'Toler noko',
                moreRisk: 'Toler meir',
            },
            infoLabel: 'Om risiko',
            infoTitle: 'Om risikotoleranse',
        },
        summary: {
            title: 'Forslag til fondstype',
            lessRisk: 'Mindre risiko',
            moreRisk: 'Meir risiko',
            fundTypes: {
                FIXED_INCOME: 'Rentefond',
                BALANCED: 'Kombinasjonsfond',
                EQUITY: 'Aksjefond',
            },
            riskLevels: {
                FIXED_INCOME: 'Lågare risiko',
                BALANCED: 'Middels risiko',
                EQUITY: 'Høgare risiko',
            },
            recommendationLabel: 'Tilrådd fondstype',
            showFunds: 'Sjå fonda som passar',
            showExplanation: 'Sjå kvifor denne fondstypen blir føreslått',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvc2hhcmVkL3RyYW5zbGF0aW9ucy9mdW5kLWd1aWRlL25uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBOEI7SUFDbEQsU0FBUyxFQUFFO1FBQ1AsV0FBVyxFQUFFO1lBQ1QsS0FBSyxFQUFFLGdCQUFnQjtZQUN2QixjQUFjLEVBQUUsZ0JBQWdCO1lBQ2hDLE1BQU0sRUFBRSxvQ0FBb0M7WUFDNUMsT0FBTyxFQUFFLHNCQUFzQjtZQUMvQixLQUFLLEVBQUUsOERBQThEO1lBQ3JFLFVBQVUsRUFBRSxvQ0FBb0M7WUFDaEQsU0FBUyxFQUFFLDZEQUE2RDtZQUN4RSxLQUFLLEVBQUUsWUFBWTtTQUN0QjtRQUNELEtBQUssRUFBRSxvQkFBb0I7UUFDM0IsZ0JBQWdCLEVBQ1osNEtBQTRLO1FBQ2hMLFlBQVksRUFBRSxLQUFLO1FBQ25CLFlBQVksRUFBRTtZQUNWLEtBQUssRUFBRSxjQUFjO1lBQ3JCLE9BQU8sRUFBRTtnQkFDTCxhQUFhLEVBQUUsWUFBWTtnQkFDM0IsY0FBYyxFQUFFLFFBQVE7Z0JBQ3hCLGFBQWEsRUFBRSxPQUFPO2FBQ3pCO1lBQ0QsU0FBUyxFQUFFLGFBQWE7WUFDeEIsU0FBUyxFQUFFLGlCQUFpQjtTQUMvQjtRQUNELGFBQWEsRUFBRTtZQUNYLEtBQUssRUFBRSxpQkFBaUI7WUFDeEIsT0FBTyxFQUFFO2dCQUNMLFFBQVEsRUFBRSxXQUFXO2dCQUNyQixRQUFRLEVBQUUsWUFBWTtnQkFDdEIsUUFBUSxFQUFFLFlBQVk7YUFDekI7WUFDRCxTQUFTLEVBQUUsV0FBVztZQUN0QixTQUFTLEVBQUUsb0JBQW9CO1NBQ2xDO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsS0FBSyxFQUFFLHVCQUF1QjtZQUM5QixRQUFRLEVBQUUsZUFBZTtZQUN6QixRQUFRLEVBQUUsYUFBYTtZQUN2QixTQUFTLEVBQUU7Z0JBQ1AsWUFBWSxFQUFFLFdBQVc7Z0JBQ3pCLFFBQVEsRUFBRSxrQkFBa0I7Z0JBQzVCLE1BQU0sRUFBRSxXQUFXO2FBQ3RCO1lBQ0QsVUFBVSxFQUFFO2dCQUNSLFlBQVksRUFBRSxlQUFlO2dCQUM3QixRQUFRLEVBQUUsZ0JBQWdCO2dCQUMxQixNQUFNLEVBQUUsZUFBZTthQUMxQjtZQUNELG1CQUFtQixFQUFFLG1CQUFtQjtZQUN4QyxTQUFTLEVBQUUsc0JBQXNCO1lBQ2pDLGVBQWUsRUFBRSw0Q0FBNEM7U0FDaEU7S0FDSjtDQUNKLENBQUMifQ==